import { ReactNode } from 'react'

import { TileTitle } from './styles'

interface ITitleProps {
  children: ReactNode
}

export function Title({ children }: ITitleProps) {
  return <TileTitle>{children}</TileTitle>
}
